/** Shared surface for report navigation sidebars (nav column + left rail). */
export const APP_SHELL_SIDEBAR_SURFACE_CLASS = 'border-r bg-muted/30';

/** Report / live-data / settings navigation column in the double-sidebar shell. */
export const APP_SHELL_NAV_SECTION_CLASS = `flex h-full max-w-49.5 min-w-51.75 basis-0 flex-col justify-between overflow-hidden ${APP_SHELL_SIDEBAR_SURFACE_CLASS}`;

/** Chart edit layout: one sidebar replacing left rail (56px) + navigation section (min-w-51.75). */
export const APP_SHELL_COMBINED_SIDEBAR_WIDTH_CLASS =
  'w-[calc(56px+var(--spacing)*51.75)] min-w-[calc(56px+var(--spacing)*51.75)] shrink-0 flex-none';

export const APP_SHELL_CHART_PAGE_SIDEBAR_CLASS = `${APP_SHELL_COMBINED_SIDEBAR_WIDTH_CLASS} ${APP_SHELL_SIDEBAR_SURFACE_CLASS} flex h-full min-h-0 flex-col overflow-y-auto`;
